import { render, staticRenderFns } from "./PollutionalertsModals.vue?vue&type=template&id=6e334dd2"
import script from "./PollutionalertsModals.vue?vue&type=script&lang=js"
export * from "./PollutionalertsModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports